import { currencyFormat, formatDateShortMon } from '../../../Functions';
import NumToWord from 'number-to-words';

export function WBHeaDCompose(page, rowL, wb, dataUrl, data) {
    var doc = wb;
    var _y = rowL;
    var _space = page.spacingunit;

    var imageX = 10;

    // var splitAddress = doc.splitTextToSize(data.placedIssuedAddress ? data.placedIssuedAddress : '', 80);

    // var dataContactOrigin = data.originBranchName + ' ' + data.originTellNum;
    // var dataContactDest = data.destinationBranchName + ' ' + data.destinationTellNum;
    // var splitContact = doc.splitTextToSize(dataContactOrigin + '\n' + dataContactDest, 50);

    _y -= _space;
    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, 50, 18);

    doc.setFont("times", "bold");
    // doc.text(10, _y + (_space * 3), splitAddress);

    // doc.text(splitContact, 200, _y, null, null, 'right');

    // _y += _space * 2;

    return _y;
}

export function WBCustomerCompose(page, rowL, wb, data) {
    var doc = wb;
    var _y = rowL;
    var _space = page.spacingunit;

    let current_datetime = new Date()
    let formatted_date = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds()

    _y += _space;

    var branchName = data.branchName ? data.branchName : '';
    var splitBranch = doc.splitTextToSize(branchName + ' BRANCH', 40);

    var branchL = splitBranch.length > 1 ? splitBranch.length * .90 : splitBranch.length;

    doc.text(splitBranch, 110, _y, null, null, 'center');

    doc.text(135, _y, 'Date Printed: ' + formatted_date);
    doc.text(135, _y + _space, 'Control No:');
    doc.text(161, _y + _space, data.wayBIllRef ? data.wayBIllRef : '');
    doc.setFontSize(12);

    _y += (_space * branchL);

    doc.text('Waybill', 110, _y, null, null, 'center');
    doc.setFontSize(10);
    
    // if(data.oldWaybillRef){
    //     // _y += _space;
    //     doc.text(10, _y, 'Old Waybill Ref: ' + data.oldWaybillRef);
    // }

    if(data.bookingRef){
        _y += _space;
        doc.text(135, _y, 'Booking Ref:       ' + data.bookingRef);
    }

    // if(data.oldBookingRef){
    //     // _y += _space;
    //     doc.text(10, _y, 'Old Booking Ref: ' + data.oldBookingRef);
    // }

    _y += _space;
    let grounded_datetime = data.dateGrounded ? new Date(data.dateGrounded) : new Date();
    let groundedFormatted_date = (grounded_datetime.getMonth() + 1) + "/" + grounded_datetime.getDate() + "/" + grounded_datetime.getFullYear();
    doc.text(135, _y, 'Date Grounded: ' + groundedFormatted_date);
    doc.setFont("times", "normal");


    _y += _space;

    doc.setFont("times", "bold");
    doc.text(10, _y, 'Shipper');
    doc.setFont("times", "normal");
    var ShipperName = data.shipperPreferedName ? data.shipperPreferedName : data.shipperName ? data.shipperName : '';
    // var ShipperName = data.shipperName ? data.shipperName : '';
    // var ShipperName = data.shipperName ? data.shipperName : '';
    doc.text(35, _y, ShipperName);
    doc.line(35, _y + 1, 200, _y + 1);

    // if(data.shipperPreferedName && data.shipperPreferedName !== ''){
    //     _y += _space;
    //     doc.setFont("times", "bold");
    //     doc.text(10, _y, 'Preferred Name');
    //     doc.setFont("times", "normal");
    //     doc.text(35, _y, data.shipperPreferedName ? data.shipperPreferedName : '');
    //     doc.line(35, _y + 1, 200, _y + 1);
    // }

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, 'Address');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.shipperAddress ? data.shipperAddress : '');
    doc.line(35, _y + 1, 200, _y + 1);

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, 'Telephone');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.shipperContactNum ? data.shipperContactNum : '');
    doc.line(35, _y + 1, 200, _y + 1);

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, 'Pickup Addr.');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.shipperPickUpAddress ? data.shipperPickUpAddress : '');
    doc.line(35, _y + 1, 200, _y + 1);

    _y += _space * 1.5;

    doc.setFont("times", "bold");
    doc.text(10, _y, 'Consignee');
    doc.setFont("times", "normal");
    var ConsigneeName = data.consigneePreferedName ? data.consigneePreferedName : data.consigneeName ? data.consigneeName : '';
    // var ConsigneeName = data.consigneeName ? data.consigneeName : '';
    doc.text(35, _y, ConsigneeName);
    doc.line(35, _y + 1, 200, _y + 1);

    // if(data.consigneePreferedName && data.consigneePreferedName !== ''){
    //     _y += _space;
    //     doc.setFont("times", "bold");
    //     doc.text(10, _y, 'Preferred Name');
    //     doc.setFont("times", "normal");
    //     doc.text(35, _y, data.consigneePreferedName ? data.consigneePreferedName : '');
    //     doc.line(35, _y + 1, 200, _y + 1);
    // }

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, 'Address');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.consigneeAddress ? data.consigneeAddress : '');
    doc.line(35, _y + 1, 200, _y + 1);

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, 'Telephone');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.consigneeContactNum ? data.consigneeContactNum : '');
    doc.line(35, _y + 1, 200, _y + 1);

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, 'Delivery Addr.');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.consigneePickUpAddress ? data.consigneePickUpAddress : '');
    doc.line(35, _y + 1, 200, _y + 1);

    return _y;
}

export function WBCargoCompose(page, rowL, wb, data) {
    var doc = wb;
    var _y = rowL;
    var _space = page.spacingunit;

    _y += _space * 1.5;
    doc.setFont("times", "bold");
    doc.text(10, _y, 'Trucker');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.truckerName ? data.truckerName : '');
    doc.line(35, _y + 1, 200, _y + 1);

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, 'Driver');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.driver ? data.driver : '');
    doc.line(35, _y + 1, 100, _y + 1);

    // _y += _space;
    doc.setFont("times", "bold");
    doc.text(105, _y, 'Plate No.');
    doc.setFont("times", "normal");
    doc.text(135, _y, data.plateNum ? data.plateNum : '');
    doc.line(135, _y + 1, 200, _y + 1);

    _y += _space * 1.5;

    doc.setFont("times", "bold");
    doc.text(10, _y, 'Voyage Ref');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.voyageRef ? data.voyageRef : '');
    doc.line(35, _y + 1, 100, _y + 1);

    _y += _space;

    doc.setFont("times", "bold");
    doc.text(10, _y, 'Est. Vessel');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.vesselName ? data.vesselName : '');
    doc.line(35, _y + 1, 100, _y + 1);

    doc.setFont("times", "bold");
    doc.text(105, _y, 'Origin');
    doc.setFont("times", "normal");
    doc.text(135, _y, data.originBranchName ? data.originBranchName : '');
    doc.line(135, _y + 1, 200, _y + 1);
    _y += _space;

    doc.setFont("times", "bold");
    doc.text(10, _y, 'Voyage');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.voyageNum ? data.voyageNum : '');
    doc.line(35, _y + 1, 100, _y + 1);

    doc.setFont("times", "bold");
    doc.text(105, _y, 'Destination');
    doc.setFont("times", "normal");
    doc.text(135, _y, data.destinationBranchName ? data.destinationBranchName : '');
    doc.line(135, _y + 1, 200, _y + 1);
    _y += _space;

    if (data.actualVesselName) {
        doc.setFont("times", "bold");
        doc.text(10, _y, 'Actual VSL');
        doc.setFont("times", "normal");
        doc.text(35, _y, data.actualVesselName ? data.actualVesselName : '');
        doc.line(35, _y + 1, 100, _y + 1);
    }

    doc.setFont("times", "bold");
    doc.text(105, _y, 'Mode of Delivery');
    doc.setFont("times", "normal");
    doc.text(135, _y, data.modeOfDeliveryName ? data.modeOfDeliveryName : '');
    doc.line(135, _y + 1, 200, _y + 1);

    _y += _space;

    return _y;
}

export function WBGoodsCompose(page, rowL, wb, data) {
    var doc = wb;
    var _y = rowL;
    var _space = page.spacingunit;

    doc.setFont("times", "bold");
    doc.text(10, _y, 'Qty');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.quantity ? data.quantity.toString() : '0');
    doc.line(35, _y + 1, 55, _y + 1);

    doc.setFont("times", "bold");
    doc.text(60, _y, 'Size');
    doc.setFont("times", "normal");
    doc.text(70, _y, data.size ? data.size : '');
    doc.line(70, _y + 1, 100, _y + 1);

    doc.setFont("times", "bold");
    doc.text(105, _y, 'Cargo');
    doc.setFont("times", "normal");
    // doc.text(135, _y, data.goods === "goodOthers" && data.goodOthers ? data.goodOthers : data.goods ? data.goods : '');
    var splitGoods = doc.splitTextToSize(data.goods === "goodOthers" && data.goodOthers ? data.goodOthers : data.goods ? data.goods : '', 65);
    doc.text(135, _y, splitGoods);
    if (splitGoods.length > 1) {
        _y += ((_space * 0.5) * splitGoods.length)
    }
    doc.line(135, _y + 1, 200, _y + 1);
    _y += _space;

    doc.setFont("times", "bold");
    doc.text(10, _y, 'Van No.');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.containerVanNum ? data.containerVanNum : '');
    doc.line(35, _y + 1, 100, _y + 1);

    doc.setFont("times", "bold");
    doc.text(105, _y, 'Declared Value');
    doc.setFont("times", "normal");
    doc.text(135, _y, data.declaredValue !== 0 ? currencyFormat(data.declaredValue) : '0');
    doc.line(135, _y + 1, 200, _y + 1);
    _y += _space;

    doc.setFont("times", "bold");
    doc.text(10, _y, 'Seal No.');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.sealNum ? data.sealNum : '');
    doc.line(35, _y + 1, 100, _y + 1);

    doc.setFont("times", "bold");
    doc.text(105, _y, 'Tonage');
    doc.setFont("times", "normal");
    doc.text(135, _y, data.cargoWeight !== 0 ? data.cargoWeight.toString() : '0');
    doc.line(135, _y + 1, 200, _y + 1);
    _y += _space;

    doc.setFont("times", "bold");
    doc.text(10, _y, 'CY In');
    doc.setFont("times", "normal");
    doc.text(35, _y, data.cyInName ? data.cyInName : data.cyIn ? data.cyIn : '');
    doc.line(35, _y + 1, 100, _y + 1);

    doc.setFont("times", "bold");
    doc.text(105, _y, 'CBM');
    doc.setFont("times", "normal");
    doc.text(135, _y, data.cargoVolume !== 0 ? data.cargoVolume.toString() : '0');
    doc.line(135, _y + 1, 200, _y + 1);

    // _y += _space;

    

    _y += _space * 1.5;

    return _y;
}

// export function WBGoodsCompose(page, rowL, wb, data) {
//     var doc = wb;
//     var _y = rowL;
//     var _space = page.spacingunit;

//     doc.setFont("times", "bold");
//     doc.text(10, _y, 'Qty');
//     doc.setFont("times", "normal");
//     doc.text(35, _y, data.quantity ? data.quantity.toString() : '0');
//     doc.line(35, _y + 1, 100, _y + 1);

//     doc.setFont("times", "bold");
//     doc.text(105, _y, 'Cargo');
//     doc.setFont("times", "normal");
//     // doc.text(135, _y, data.goods === "goodOthers" && data.goodOthers ? data.goodOthers : data.goods ? data.goods : '');
//     var splitGoods = doc.splitTextToSize(data.goods === "goodOthers" && data.goodOthers ? data.goodOthers : data.goods ? data.goods : '', 65);
//     doc.text(135, _y, splitGoods);
//     if (splitGoods.length > 1) {
//         _y += ((_space * 0.5) * splitGoods.length)
//     }
//     doc.line(135, _y + 1, 200, _y + 1);
//     _y += _space;

//     doc.setFont("times", "bold");
//     doc.text(10, _y, 'Size');
//     doc.setFont("times", "normal");
//     doc.text(35, _y, data.size ? data.size : '');
//     doc.line(35, _y + 1, 100, _y + 1);

//     doc.setFont("times", "bold");
//     doc.text(105, _y, 'Declared Value');
//     doc.setFont("times", "normal");
//     doc.text(135, _y, data.declaredValue !== 0 ? currencyFormat(data.declaredValue) : '0');
//     doc.line(135, _y + 1, 200, _y + 1);
//     _y += _space;

//     doc.setFont("times", "bold");
//     doc.text(10, _y, 'Van No.');
//     doc.setFont("times", "normal");
//     doc.text(35, _y, data.containerVanNum ? data.containerVanNum : '');
//     doc.line(35, _y + 1, 100, _y + 1);

//     doc.setFont("times", "bold");
//     doc.text(105, _y, 'Tonage');
//     doc.setFont("times", "normal");
//     doc.text(135, _y, data.cargoWeight !== 0 ? data.cargoWeight.toString() : '0');
//     doc.line(135, _y + 1, 200, _y + 1);
//     _y += _space;

//     doc.setFont("times", "bold");
//     doc.text(10, _y, 'Seal No.');
//     doc.setFont("times", "normal");
//     doc.text(35, _y, data.sealNum ? data.sealNum : '');
//     doc.line(35, _y + 1, 100, _y + 1);

//     doc.setFont("times", "bold");
//     doc.text(105, _y, 'CBM');
//     doc.setFont("times", "normal");
//     doc.text(135, _y, data.cargoVolume !== 0 ? data.cargoVolume.toString() : '0');
//     doc.line(135, _y + 1, 200, _y + 1);

//     _y += _space;

//     doc.setFont("times", "bold");
//     doc.text(10, _y, 'CY In');
//     doc.setFont("times", "normal");
//     doc.text(35, _y, data.cyInName ? data.cyInName : data.cyIn ? data.cyIn : '');
//     doc.line(35, _y + 1, 100, _y + 1);

//     // _y += _space;

//     // doc.setFont("times", "bold");
//     // doc.text(10, _y, 'Van Locator');
//     // doc.setFont("times", "normal");
//     // doc.text(35, _y, data.vanLocator ? data.vanLocator : '');
//     // doc.line(35, _y + 1, 100, _y + 1);

//     // doc.setFont("times", "bold");
//     // doc.text(105, _y, 'Van Locator Amount');
//     // doc.setFont("times", "normal");
//     // doc.text(145, _y, data.vanLocatorAmount && data.vanLocatorAmount !== 0 ? data.vanLocatorAmount.toString() : '');
//     // doc.line(145, _y + 1, 200, _y + 1);

//     _y += _space * 1.5;

//     return _y;
// }

export function WBChargeCompose(page, rowL, wb, data) {
    var doc = wb;
    var _y = rowL;
    var _space = page.spacingunit;

    doc.setFont("times", "bold");
    doc.text(10, _y, 'Charge');
    doc.text(110, _y, 'Prepaid', null, null, 'right');
    doc.text(140, _y, 'Collect', null, null, 'right');
    doc.text(170, _y, 'Acct Origin', null, null, 'right');
    doc.text(200, _y, 'Acct Dest', null, null, 'right');
    doc.setFont("times", "normal");
    doc.line(10, _y + 1, 200, _y + 1);

    _y += _space;

    // eslint-disable-next-line
    data.createWayBillCharges.map(wbChrg => {
        doc.text(10, _y, wbChrg.particulars);
        if (wbChrg.availableTo === "Prepaid") {
            doc.text(110, _y, wbChrg.chargeValue ? 'XXXX' : '-', null, null, 'right');
            // doc.text(110, _y, wbChrg.chargeValue ? currencyFormat(wbChrg.chargeValue) : '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else if (wbChrg.availableTo === "Collect") {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, wbChrg.chargeValue ? 'XXXX' : '-', null, null, 'right');
            // doc.text(140, _y, wbChrg.chargeValue ? currencyFormat(wbChrg.chargeValue) : '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else if (wbChrg.availableTo === "Account Origin") {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, wbChrg.chargeValue ? 'XXXX' : '-', null, null, 'right');
            // doc.text(170, _y, wbChrg.chargeValue ? currencyFormat(wbChrg.chargeValue) : '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, wbChrg.chargeValue ? 'XXXX' : '-', null, null, 'right');
            // doc.text(200, _y, wbChrg.chargeValue ? currencyFormat(wbChrg.chargeValue) : '-', null, null, 'right');
        }
        doc.line(10, _y + 1, 200, _y + 1);
        _y += _space;
    })
    if(data.isSplitCharges){
        doc.text(10, _y, data.outboundParticulars);
        if (data.outboundAvailableTo === "Prepaid") {
            doc.text(110, _y, data.outboundDemmurage ? 'XXXX' : '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else if (data.outboundAvailableTo === "Collect") {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, data.outboundDemmurage ? 'XXXX' : '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else if (data.outboundAvailableTo === "Account Origin") {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, data.outboundDemmurage ? 'XXXX' : '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, data.outboundDemmurage ? 'XXXX' : '-', null, null, 'right');
        }
        doc.line(10, _y + 1, 200, _y + 1);
        _y += _space;
        doc.text(10, _y, data.inboundParticulars);
        if (data.inboundAvailableTo === "Prepaid") {
            doc.text(110, _y, data.inboundDemmurage ? 'XXXX' : '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else if (data.inboundAvailableTo === "Collect") {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, data.inboundDemmurage ? 'XXXX' : '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else if (data.inboundAvailableTo === "Account Origin") {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, data.inboundDemmurage ? 'XXXX' : '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, data.inboundDemmurage ? 'XXXX' : '-', null, null, 'right');
        }
        doc.line(10, _y + 1, 200, _y + 1);
        _y += _space;
        doc.text(10, _y, data.storageFeParticulars);
        if (data.storageFeeAvailableTo === "Prepaid") {
            doc.text(110, _y, data.storageFee ? 'XXXX' : '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else if (data.storageFeeAvailableTo === "Collect") {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, data.storageFee ? 'XXXX' : '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else if (data.storageFeeAvailableTo === "Account Origin") {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, data.storageFee ? 'XXXX' : '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, data.storageFee ? 'XXXX' : '-', null, null, 'right');
        }
        doc.line(10, _y + 1, 200, _y + 1);
        _y += _space;
    }

    if(data.FormAction === 'Create' && data.INSParticulars && data.INSAvailableTo && data.insurancePremium){
        doc.text(10, _y, data.INSParticulars);
        if (data.INSAvailableTo === "Prepaid") {
            doc.text(110, _y, data.insurancePremium ? 'XXXX' : '-', null, null, 'right');
            // doc.text(110, _y, data.insurancePremium ? data.insurancePremium : '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else if (data.INSAvailableTo === "Collect") {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, data.insurancePremium ? 'XXXX' : '-', null, null, 'right');
            // doc.text(140, _y, data.insurancePremium ? data.insurancePremium : '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else if (data.INSAvailableTo === "Account Origin") {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, data.insurancePremium ? 'XXXX' : '-', null, null, 'right');
            // doc.text(170, _y, data.insurancePremium ? data.insurancePremium : '-', null, null, 'right');
            doc.text(200, _y, '-', null, null, 'right');
        }
        else {
            doc.text(110, _y, '-', null, null, 'right');
            doc.text(140, _y, '-', null, null, 'right');
            doc.text(170, _y, '-', null, null, 'right');
            doc.text(200, _y, data.insurancePremium ? 'XXXX' : '-', null, null, 'right');
            //  doc.text(200, _y, data.insurancePremium ? data.insurancePremium : '-', null, null, 'right');
        }
        doc.line(10, _y + 1, 200, _y + 1);
        _y += _space;
    }

    doc.setFont("times", "bold");
    doc.text(10, _y, 'Total    =');
    doc.text(40, _y, 'XXXX');
    doc.text(110, _y, data.totalPrepaid !== 0 ? 'XXXX' : '-', null, null, 'right');
    doc.text(140, _y, data.totalCollect !== 0 ? 'XXXX' : '-', null, null, 'right');
    doc.text(170, _y, data.totalAccountOrigin !== 0 ? 'XXXX' : '-', null, null, 'right');
    doc.text(200, _y, data.totalAccountDestination !== 0 ? 'XXXX' : '-', null, null, 'right');
    // doc.text(40, _y, 'P' + currencyFormat(data.totalOverAll));
    // doc.text(110, _y, data.totalPrepaid !== 0 ? currencyFormat(data.totalPrepaid) : '-', null, null, 'right');
    // doc.text(140, _y, data.totalCollect !== 0 ? currencyFormat(data.totalCollect) : '-', null, null, 'right');
    // doc.text(170, _y, data.totalAccountOrigin !== 0 ? currencyFormat(data.totalAccountOrigin) : '-', null, null, 'right');
    // doc.text(200, _y, data.totalAccountDestination !== 0 ? currencyFormat(data.totalAccountDestination) : '-', null, null, 'right');

    doc.setFont("times", "normal");
    doc.line(10, _y + 1, 200, _y + 1);

    _y += _space * 2;

    return _y;
}

export function WBFinalCompose(page, rowL, wb, data, user) {
    var doc = wb;
    var _y = rowL;
    var _space = page.spacingunit;

    var splitRemark = doc.splitTextToSize(data.remarks ? data.remarks : '', 125);

    var c1 = data.createWayBillTerms.find(function (TC) {
        return TC.policyCode === "C0001"
    });

    var c1F = c1 !== undefined && c1.stdValueInDecimalApplied ? c1.stdValueInDecimalApplied : 0

    var c3 = data.createWayBillTerms.find(function (TC) {
        return TC.policyCode === "C0003"
    });

    var c3F = c3 !== undefined && c3.stdValueInDecimalApplied ? c3.stdValueInDecimalApplied : 0

    var c7 = data.createWayBillTerms.find(function (TC) {
        return TC.policyCode === "C0007"
    });

    var c7F = c7 !== undefined && c7.stdValueInDecimalApplied ? c7.stdValueInDecimalApplied : 0
    
    var C3Final = c3F !== 0 ? currencyFormat(c3F).toString() : '0';
   
    var splitT1 = doc.splitTextToSize('Claims on damaged or missing cargoes shall only be entertained within ' + NumToWord.toWords(c7F) + ' (' + (c7F).toString() + ') days from the date of vessel arrival.', page.maxWidthInPoint);
    var splitT2 = doc.splitTextToSize('Claim must be attested by a representative of Ocean Transport upon discovery.', page.maxWidthInPoint);
    var splitT3 = doc.splitTextToSize('Claimant must submit to Ocean Transport a claim letter and packaging list of the cargo.', page.maxWidthInPoint);
    var splitT4 = doc.splitTextToSize('Storage fee of ' + C3Final + ' a day per van in excess of ' + NumToWord.toWords(c1F) + ' (' + (c1F).toString() + ') days free storage.', page.maxWidthInPoint);
    var splitT5 = doc.splitTextToSize('All cargoes are "Shipper`s load, count and sealed", ', page.maxWidthInPoint);

    var T1L = splitT1.length > 1 ? splitT1.length * .80 : splitT1.length;
    var T2L = splitT2.length > 1 ? splitT2.length * .80 : splitT2.length;
    var T3L = splitT3.length > 1 ? splitT3.length * .80 : splitT3.length;
    var T4L = splitT4.length > 1 ? splitT4.length * .80 : splitT4.length;
    var T5L = splitT5.length > 1 ? splitT5.length * .80 : splitT5.length;

    var splitPlaceIssued = doc.splitTextToSize(data.placedIssuedAddress ? data.placedIssuedAddress : '', 160);

    doc.setFont("times", "bold");
    doc.text(10, _y, 'Remarks');
    doc.setFont("times", "normal");
    doc.text(30, _y, splitRemark);
    doc.line(30, _y + 1, 125, _y + 1);

    doc.line(135, _y + 1, 200, _y + 1);
    _y += _space;
    doc.text(145, _y, 'Shipper Authorized Signature');

    _y += (_space / 2);

    doc.setFont("times", "bold");
    doc.text(10, _y, 'Important Notice:');
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(15, _y, '1.');
    doc.text(20, _y, splitT1);
    _y += (_space * T1L);

    doc.text(15, _y, '2.');
    doc.text(20, _y, splitT2);
    _y += (_space * T2L);

    doc.text(15, _y, '3.');
    doc.text(20, _y, splitT3);
    _y += (_space * T3L);

    doc.text(15, _y, '4.');
    doc.text(20, _y, splitT4);
    _y += (_space * T4L);

    doc.text(15, _y, '5.');
    doc.text(20, _y, splitT5);
    _y += (_space * T5L);

    _y += (_space / 2);
    doc.setFont("times", "bold");
    doc.text(10, _y, 'Date Prepared');
    doc.setFont("times", "normal");
    doc.text(40, _y, data.datePrepared ? formatDateShortMon(data.datePrepared) : '');
    doc.line(40, _y + 1, 105, _y + 1);

    doc.setFont("times", "bold");
    doc.text(112, _y, 'Issued By');
    doc.setFont("times", "normal");
    doc.text(135, _y, user.name);
    doc.line(135, _y + 1, 200, _y + 1);

    _y += _space;
    doc.setFont("times", "bold");
    doc.text(10, _y, 'Place Issued');
    doc.setFont("times", "normal");
    doc.text(40, _y, splitPlaceIssued);
    if (splitPlaceIssued.length > 1) {
        for (let index = 0; index < splitPlaceIssued.length; index++) {
            doc.line(40, _y + .8, 200, _y + .8);
            _y += _space * .80;
        }
    }
    else {
        doc.line(40, _y + 1, 200, _y + 1);
        _y += _space;
    }
}